import type { FaireProductEntity } from "../../entity_types/product";

export const p_dikpnp7sbh: FaireProductEntity = {
  token: "p_dikpnp7sbh",
  type: "product",
  name: "7 Chakra Tea Organic Herbal Tea - Tin of 15 Tea Sachets",
  brandToken: "b_5bw8e8irqb",
  brandName: "Boulder Tea Company",
  imageUrl:
    "https://cdn.faire.com/fastly/e1f31ec4408e53c5dfcdd067d32f1f7aacc3730a88bcb30f699d3746e7970643.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c883f19408acaadd0a9dbdeff9664494e8cc8b7a689925a4f22d9e1e1269df66.jpeg",
    "https://cdn.faire.com/fastly/2e00bba06feaae3622154effa0d711534fdd49b0d0cb19a2943cab1cbed21758.jpeg",
    "https://cdn.faire.com/fastly/908ad1bcd4c3d9e94c899f0f6a4d5d01985b05a8672fce49863c74755ab6cb91.jpeg",
  ],
  priceDollars: 11.78,
  description:
    "7 Chakra Tea™ organic herbal tea blend - Our signature tin of 15 tea sachets.\nThis delicious blend was created exclusively for the Dushanbe Teahouse by renowned herbalist and wellness expert Brigitte Mars. 7 Chakra organic herbal tea ‘balances and supports intrinsic human energies’ (“Chakras”). Most of these tonifying, balancing herbs are indigenous to the Rocky Mountain region. Each puts forth an exquisite, revitalizing boost of solid botanical goodness – and no caffeine. \nAll ingredients are organic: Blackberry, Dandelion, Elderberries, Hawthorn, Nettle, Rosehips, Spearmint Leaf",
  tags: [],
  msrpDollars: 16.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:51.359Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
